import { apiUtils } from '../utils/api';
import { API_ENDPOINTS } from '../constants';

const { ROOT } = API_ENDPOINTS.CONTACT;

export const submitContact = (payload) => apiUtils.post(ROOT, payload);
export const getContactSubmissions = (params = {}) => apiUtils.get(ROOT, { params });
export const updateContactSubmission = (id, payload) => apiUtils.patch(`${ROOT}${id}/`, payload);
